// chat-interfaces.ts

export interface AgentDetails {
  processCd: string;
  agentId: string;
  agentName: string;
  applicationId?: string;
}

// Interface for Add Agent input data
export interface AddAgentInputData {
  firstName: string;
  lastName: string;
  userName: string;
  password: string;
  zoneName: string;
  sourceType: string;
  sourceUserName: string;
  sourcePassword: string;
  sourceUrl: string;
  models: number[];
  processCd: string;
  processName: string;
  email: string;
  phoneNum: string;
  serviceType: string;
  serviceCd: string;
  agentId: string;
  agentName: string;
  querynodeCmsExampleQuestions: string;
  querynodeCmsInstructions: string;
  querynodeEventExampleQuestions: string;
  querynodeEventInstructions: string;
  processSummary: string;
  eventVideos: string;
}

// Enhanced Chat Interfaces
export interface ChatMessage {
  id: string;
  text: string;
  isUser: boolean;
  timestamp: string;
  isLoading?: boolean;
  progress?: number;
  showAgentConfirmation?: boolean;
  // --- FIX: Standardize on using the complete AgentMetadata object ---
  agentMetadata?: AgentMetadata | null;
  // The 'agentDetails' property has been removed to avoid conflicts.
  currentStep?: string;
  milestoneStep?: number;
}

export interface ChatState {
  messages: ChatMessage[];
  loading: boolean;
  generationProgress: number;
  currentStep: string;
  currentRequestId: string | null;
  error: string | null;
  currentMilestone: number;
  totalMilestones: number;
}

export interface ApiResponse {
  status_code: number;
  status: boolean;
  message: string;
  error: string | null;
  data: {
    zip_path: string;
    metadata: AgentMetadata; // this is a JSON string
  };
}

// If you want to parse metadata into a proper object:
export interface AgentMetadata {
  metadata: {
    requestId: string;
    applicationId: string;
    applicationType: string;
  };
  agent: {
    lobCd: string;
    lobName: string;
    serviceCd: string;
    serviceName: string;
    processCd: string;
    processName: string;
    agentId: string;
    agentName: string;
  };
  vip: {
    models: {
      id: number;
      name: string;
    }[];
    name: string;
    description: string;
    sourceType: string;
  };
  node_prompts: {
    querynode_cms_example_questions: string;
    querynode_cms_instructions: string;
    querynode_event_example_questions: string;
    querynode_event_instructions: string;
    process_summary: string;
    event_videos: string;
  };
}

export interface NodePromtdetails {
  querynode_cms_example_questions: string;
  querynode_cms_instructions: string;
  querynode_event_example_questions: string;
  querynode_event_instructions: string;
  process_summary: string;
  event_videos: string;
}

export const GENERATION_MILESTONES = [
  {
    step: 1,
    agent: "Planner Agent",
    message: "Analyzing the prompt",
    progress: 5,
  },
  {
    step: 2,
    agent: "Planner Agent",
    message: "Blue Print generated",
    progress: 10,
  },
  {
    step: 3,
    agent: "Planner Agent",
    message: "Handover to Orchestrator Agent",
    progress: 14,
  },
  {
    step: 4,
    agent: "Orchestrator Agent",
    message: "Orchestration to Coder Agents complete",
    progress: 18,
  },
  {
    step: 5,
    agent: "Coder Agent",
    message: "Generating required objects in progress",
    progress: 23,
  },
  {
    step: 6,
    agent: "Coder Agent",
    message: "Application generated",
    progress: 28,
  },
  {
    step: 7,
    agent: "Coder Agent",
    message: "Custom data types generated",
    progress: 33,
  },
  {
    step: 8,
    agent: "Coder Agent",
    message: "Connected systems generated",
    progress: 38,
  },
  {
    step: 9,
    agent: "Coder Agent",
    message: "Integration details generated",
    progress: 43,
  },
  {
    step: 10,
    agent: "Coder Agent",
    message: "Record type details and table commands generated",
    progress: 48,
  },
  {
    step: 11,
    agent: "Coder Agent",
    message: "Rule details generated",
    progress: 52,
  },
  {
    step: 12,
    agent: "Connector Agent",
    message: "Integrating the objects",
    progress: 57,
  },
  {
    step: 13,
    agent: "Connector Agent",
    message: "Integration complete",
    progress: 62,
  },
  {
    step: 14,
    agent: "Coder Agent",
    message: "Web APIs generated",
    progress: 67,
  },
  {
    step: 15,
    agent: "Connector Agent",
    message: "Handover to Validation Agent",
    progress: 71,
  },
  {
    step: 16,
    agent: "Coder Agent",
    message: "Objects generated",
    progress: 76,
  },
  {
    step: 17,
    agent: "Validation Agent",
    message: "Validation in-progress",
    progress: 81,
  },
  {
    step: 18,
    agent: "Validation Agent",
    message: "Validation successful",
    progress: 86,
  },
  {
    step: 19,
    agent: "Packaging Agent",
    message: "Packaging Application started",
    progress: 90,
  },
  {
    step: 20,
    agent: "Packaging Agent",
    message: "Packaging Application complete",
    progress: 95,
  },
  {
    step: 21,
    agent: "Packaging Agent",
    message: "Handover to DevOps Agent",
    progress: 100,
  },
];
